import { ColumnModel } from '../../common/types/ColumnModel';

export default class ProjectListLayout {
    id: string;
    columns: ColumnModel[];
}